import { Box, Flex, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { Pagination } from "@nens/chakra/components";
import { Scenario, useScenarioHistory } from "@nens/ldo/api-v1";
import { useTableData } from "@nens/react/hooks";

import { ScenarioStatus } from "../scenario-status/scenario-status";

interface ScenarioHistoryProps {
  scenario: Scenario;
}

export function ScenarioHistory({ scenario }: ScenarioHistoryProps) {
  const [numPages, setNumPages] = useState<number>(-1);
  const { page, limit, offset, nextPage, previousPage, setPage } = useTableData({
    initialPageSize: 15,
  });

  const historyResponse = useScenarioHistory(scenario, { limit, offset });

  const history = historyResponse.isSuccess ? historyResponse.data.items : [];

  if (numPages === -1 && historyResponse.isSuccess) {
    setNumPages(Math.ceil(historyResponse.data.total / 15));
  }

  if (history.length === 0 || numPages === -1) return null;

  return (
    <Box rounded="md" border="1px solid #ccc">
      <Flex
        borderBottom="1px solid #ccc"
        py="10px"
        px="14px"
        justifyItems={"flex-start"}
        alignItems={"center"}
      >
        <Text fontWeight={"semibold"}>
          <FormattedMessage id="detailpage.history" defaultMessage="History" />
        </Text>
        <Box
          color="bij12_1.700"
          fontWeight="semibold"
          bgColor={"#CC614D20"}
          fontSize={"sm"}
          rounded="full"
          px="14px"
          py="1px"
          ml="12px"
        >
          {historyResponse.data?.total ?? 0}
        </Box>
      </Flex>
      <Table w="full">
        <Tbody>
          {history.map((hist, idx) => (
            <Tr key={`${hist.scenario_id}-${hist.updated_at.toUTCString()}-${idx}`}>
              <Td>
                {hist.updated_at.toLocaleDateString()} {hist.updated_at.toLocaleTimeString()}
              </Td>
              <Td>{hist.updated_by.name}</Td>
              <Td>
                <ScenarioStatus status={hist.status} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {numPages > 1 ? (
        <Pagination
          toPage1={() => setPage(1)}
          toPrevious={previousPage}
          toNext={page < numPages ? nextPage : undefined}
          page={page}
          numPages={numPages}
        />
      ) : null}
    </Box>
  );
}
